import {
  DocumentAction,
  type DocumentCreationResponse,
  type DocumentPresignedDetails,
  type DocumentsAPI,
  DocumentType,
  type DocumentUploadResponse,
} from '@omnipresentgroup/types';

export const DEFAULT_EMPLOYEE_DOCUMENTS: DocumentsAPI = {
  items: [
    {
      userId: 'c71bbd7b-ddaa-423f-94e3-397641e01d0e',
      description: '',
      scanStatus: 'document-status:accepted',
      id: '6340da4d-ecc5-4fbb-b6c1-42a6968219e3',
      tenantId: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      ownerId: 'user:c71bbd7b-ddaa-423f-94e3-397641e01d0e',
      linkToDocument: null,
      type: DocumentType.DOCUMENT,
      title: 'Health Insurance Card',
      createdAt: '2022-11-10T11:14:53.126Z',
      scannedAt: '2022-11-10T11:14:57.755Z',
      actions: [DocumentAction.DELETE, DocumentAction.DOWNLOAD],
    },
    {
      userId: 'c71bbd7b-ddaa-423f-94e3-397641e01d0e',
      description: '',
      scanStatus: 'document-status:accepted',
      id: 'f516e22b-2087-49af-99df-66f348bdabd2',
      tenantId: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      ownerId: 'user:c71bbd7b-ddaa-423f-94e3-397641e01d0e',
      linkToDocument: null,
      type: DocumentType.DOCUMENT,
      title: 'Address Proof',
      createdAt: '2022-11-10T11:14:53.120Z',
      scannedAt: '2022-11-10T11:14:57.750Z',
      actions: [DocumentAction.DELETE, DocumentAction.DOWNLOAD],
    },
    {
      userId: 'c71bbd7b-ddaa-423f-94e3-397641e01d0e',
      description:
        'Contains responses to onboarding form submitted at 2022-08-23T14:55:37Z',
      scanStatus: 'document-status:internal',
      id: 'f22299c1-f8a9-41cc-afde-90cc74177149',
      tenantId: 'adc8745b-f6fa-48a7-82f0-cf82ecd8b7t4',
      ownerId: 'user:c71bbd7b-ddaa-423f-94e3-397641e01d0e',
      linkToDocument: null,
      type: DocumentType.DOCUMENT,
      title: 'Onboarding Form Summary',
      createdAt: '2022-08-23T14:55:39.644Z',
      actions: [DocumentAction.DELETE, DocumentAction.DOWNLOAD],
    },
  ],
  actions: [DocumentAction.LIST],
};

export const DEFAULT_COMPANY_DOCUMENTS = {
  items: [
    {
      description: 'Document description',
      scanStatus: 'document-status:accepted',
      id: '0d84bf93-8efa-4a15-bee3-1450df0bd8b7',
      tenantId: '9OusezqHkt1u',
      ownerId: 'company:9OusezqHkt1u',
      linkToDocument: null,
      type: DocumentType.DOCUMENT,
      title: 'omnicreate/9OusezqHkt1u/US/keyyyyy/0',
      createdAt: '2023-01-25T23:06:36.151Z',
      scannedAt: '2023-01-25T23:06:40.605Z',
      actions: [DocumentAction.DELETE, DocumentAction.DOWNLOAD],
    },
    {
      description: 'Document description',
      scanStatus: 'document-status:accepted',
      id: 'd343d50f-f78f-4abc-b53b-794060496aac',
      tenantId: '9OusezqHkt1u',
      ownerId: 'company:9OusezqHkt1u',
      linkToDocument: null,
      type: DocumentType.DOCUMENT,
      title: 'omnicreate/anothercompanyid/US/anotherkeyyyyy/0',
      createdAt: '2023-01-05T12:12:07.693Z',
      scannedAt: '2023-01-05T12:12:12.091Z',
      actions: [DocumentAction.DELETE, DocumentAction.DOWNLOAD],
    },
    {
      description: 'Document description',
      scanStatus: 'document-status:accepted',
      id: 'aa005b4d-fb77-492d-bf91-b3f667638ff1',
      tenantId: '9OusezqHkt1u',
      ownerId: 'company:9OusezqHkt1u',
      linkToDocument: null,
      type: DocumentType.DOCUMENT,
      title: 'omnicreate/9OusezqHkt1u/SA/managingDirectors/0',
      createdAt: '2023-02-10T09:30:51.309Z',
      scannedAt: '2023-02-10T09:30:56.015Z',
      actions: [DocumentAction.DELETE, DocumentAction.DOWNLOAD],
    },
  ],
  actions: [DocumentAction.LIST, DocumentAction.CREATE],
};

export const DEFAULT_PRESIGNED_DETAILS: DocumentPresignedDetails = {
  url: '',
  fields: {},
};

export const DEFAULT_DOCUMENT_UPLOAD_RESPONSE: DocumentUploadResponse = {
  documentUrl: '',
  originalFileName: '',
  uniqueIdFileName: '',
};

export const DEFAULT_DOCUMENT_CREATION_RESPONSE: DocumentCreationResponse = {
  id: '',
  message: '',
  url: '',
};
